// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chat_wrapper__UXBGp"};